import { Injectable, inject } from '@angular/core';
import { Guid } from '@web/utils';
import { map, Observable } from 'rxjs';
import { AdminMultimediaDetailsResponse } from '@web/shared/module/multimedia';
import {
  ApiDependencyProviderService,
  CreateResourceResponse,
  HttpParams,
} from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class WarehouseMultimediaApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public upload(file: File): Observable<CreateResourceResponse> {
    const path = 'admin/file/warehouse/upload';
    const url = this.provider.httpUrlFactory.simple(this.hostUrl(), path);
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .skipByLoadingInterceptor()
      .build();
    const form = new FormData();

    form.append('file', file);

    return this.provider.http
      .post(url, form, { context })
      .pipe(
        map(this.provider.httpHelper.bodyToResponse(CreateResourceResponse)),
      );
  }

  public fetchDetailsById(
    id: Guid,
    cacheable = false,
  ): Observable<AdminMultimediaDetailsResponse> {
    const path = `admin/file/warehouse/${HttpParams.Id}`;
    const url = this.provider.httpUrlFactory.withParams(this.hostUrl(), path, {
      [HttpParams.Id]: id,
    });
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .skipByLoadingInterceptor()
      .withOptionalCacheInterceptor(() => cacheable)
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToResponse(
            AdminMultimediaDetailsResponse,
          ),
        ),
      );
  }

  protected hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Storage;
  }
}
